import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "folder-opened",
  "use": "folder-opened-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"folder-opened\"><path d=\"M17.875 8.125v-2.5c0-.69-.56-1.25-1.25-1.25h-8.75v-1.25c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25v13.583a1.417 1.417 0 002.78.365l1.96-8.047a1.25 1.25 0 011.2-.901h11.56a1.25 1.25 0 011.208 1.572l-1.833 7.5a1.25 1.25 0 01-1.208.928H3.039\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/folder-opened.svg
// module id = GXoA
// module chunks = 39 44